import React, { useState } from 'react'
import { GxIcon } from '@garpix/garpix-web-components-react'
import Button from '@/components/Button'
import Container from '@/components/Container'
import Radiobutton from '@/components/Radiobutton'
import Section from '@/components/Section'
import Title from '@/components/Title'

import { IPropsQustion } from '../interfaces'
import { arrowRightIcon } from '@/images'
import style from '../styles/quiz.module.scss'

const QuizQuestion = ({
  question,
  questionsCount,
  questionNumber,
  title = '',
  userAnswer = '',
  onClickNext = () => {},
  onClickBack = () => {},
  setAnswer = () => {}
}: IPropsQustion): React.ReactElement => {
  const [value, setValue] = useState(userAnswer)

  const saveAnswer = (): void => setAnswer({ answer: value, questionNumber })

  const onChangeAnswer = (e): void => {
    const value = e.target?.value.trim() ?? ''
    setValue(value)
    setAnswer({ answer: value, questionNumber })
  }

  const goToNext = (): void => {
    saveAnswer()
    onClickNext()
  }

  const goToPrev = (): void => {
    saveAnswer()
    onClickBack()
  }

  return (
    <Container>
      <Section>
        <Title type='h2' theme='h4' className={style.step__title}>
          {title}
        </Title>

        <div className={style.step_row}>
          <img
            src={question?.preview_picture[0]}
            width='705px'
            height='705px'
            alt='Картинка к вопросу'
            className={style.step__image}
          />

          <div className={style.step_content}>
            <div className={style.step_steps}>
              <span className={style.step__current}>{questionNumber}</span>
              <span className={style.step__all}>
                {' / '}
                {questionsCount}
              </span>
            </div>

            <Title type='h3' className={style.step__question}>
              {question.name}
            </Title>

            {question.property_answers_value.map((answer, idx) => {
              const checked = answer?.trim() === value?.trim()
              return (
                <Radiobutton
                  name='option'
                  key={`answer-${idx}`}
                  className={style.step__radio}
                  value={answer}
                  checked={checked}
                  onGx-change={onChangeAnswer}
                >
                  {answer}
                </Radiobutton>
              )
            })}

            <div className={style.step_buttons}>
              {questionNumber > 1
                ? (
                  <Button
                    theme='secondary'
                    wide
                    highlight
                    size='large'
                    className={style.step__button}
                    onClick={goToPrev}
                  >
                    <GxIcon
                      src={arrowRightIcon}
                      slot='icon-left'
                      className={style.step__button_icon}
                    />
                    Назад
                  </Button>
                  )
                : null}

              <Button
                wide
                highlight
                size='large'
                className={style.step__button}
                onClick={goToNext}
              >
                Далее
              </Button>
            </div>
          </div>
        </div>
      </Section>
    </Container>
  )
}

export default QuizQuestion
